/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".qucik-filters-wrap[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;margin-bottom:20px}.quick-filter[_ngcontent-%COMP%]{cursor:pointer;border:1px solid #a6a6a6;border-radius:2px;padding:5px 10px;color:rgba(0,0,0,.87);margin-right:10px;margin-bottom:20px}.quick-filter[_ngcontent-%COMP%]:last-child{margin-right:0}.active-filter[_ngcontent-%COMP%]{background-color:#1976d2}\n/*# sourceMappingURL=quick-filters.component.css.map*/"];
export { styles as styles };
